import { trpc } from '@/shared/api/trpc';

// Itinerary-wide items (all days, resolved suppliers) for the operations
// "Information" modals. Lazy — only fetched while a modal is open.
export const useItineraryReport = (
  itineraryId: string | null,
  options?: { enabled?: boolean }
) =>
  trpc.operations.itineraryReport.useQuery(
    { itineraryId: itineraryId ?? '' },
    {
      enabled: (options?.enabled ?? true) && Boolean(itineraryId),
    }
  );
